// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"_3p1UJ","socialLinkSvg":"_3121z"};